$(function () {
fn_layout_header();
fn_layout_main();
fn_part_scroll_banner();
fn_part_ui_input();
fn_part_ui_option();
fn_part_ui_wsw();
fn_comp_about();
fn_comp_boxes();
fn_comp_gallery();
fn_comp_map();
fn_comp_spotlight();
fn_comp_visual();
});